import { Injectable } from '@angular/core';
import { HttpRequest, HttpResponse, HttpHandler, HttpEvent, 
         HttpInterceptor, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { delay, mergeMap, materialize, dematerialize } from 'rxjs/operators';

import { User } from '@app/model/user';
 
let users: User[] = 
    [{id: 1, 
      role: 1,  
      uId: 'Q8YSS0K7H',
      username: 'test1', 
      password: 'test1', 
      firstName: 'Test1', 
      lastName: 'User1'},
     {id: 2, 
      role: 2, 
      uId: 'Q8YSS0K7H',  
      username: 'test2', 
      password: 'test2', 
      firstName: 'Test2', 
      lastName: 'User2'}];

@Injectable()
export class FakeBackendInterceptor implements HttpInterceptor 
{
    intercept(request: HttpRequest<any>, next: HttpHandler):
              Observable<any> 
    {
        let { url, method, headers, body } = request;

        // wrap in delayed observable to simulate server api call
 //       return of(null)
 //           .pipe(mergeMap(handleRoute));
        // call materialize and dematerialize to ensure delay even if an error 
        // is thrown (https://github.com/Reactive-Extensions/RxJS/issues/648)        
        return of(null)       
            .pipe(mergeMap(handleRoute))
            .pipe(materialize()) 
            .pipe(delay(500))
            .pipe(dematerialize());

        function handleRoute()
        {                      
            switch (true) {
                case url.endsWith('/users/authenticate') && 
                     method === 'POST':
                    return authenticate();
                default:
                    // pass through any requests not handled above
                    return next.handle(request);                    
            }    
        }

        // route functions

        function authenticate() 
        {
            const { username, password } = body;
            const user = users.find(x => x.username === username && 
                                    x.password === password);
            if (!user)
            {
                return error('Username or password is incorrect');
            }
            else
            {
                return ok({
                    id: user.id,
                    role: user.role,
                    username: user.username,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    token: 'fake-jwt-token'
                });
            }
        }

        // helper functions

        function ok(body?) {
            return of(new HttpResponse({ status: 200, body }))
        }

        function error(message) {
            return throwError({ error: { message } });
        }

        function unauthorized() {
            return throwError({ status: 401, 
                                error: { message: 'Unauthorised' } });
        }

        function isLoggedIn() {
            return headers.get('Authorization') === 
                   `Basic ${window.btoa('test:test')}`;
        }
    }
}

export let fakeBackendProvider = {
    // use fake backend in place of Http service for backend-less development
    provide: HTTP_INTERCEPTORS,
    useClass: FakeBackendInterceptor,
    multi: true
}